
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/payments",
      function () {
        return require("private-next-pages/admin/payments/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/payments"])
      });
    }
  